import React from 'react'
import { useTaste } from '../contexts/TasteContext'
import useAsset from '../../hooks/useAsset'

const CaviarUpsell: React.FC = () => {
  const { selectedPack, hasCaviar, setHasCaviar, caviarPrice } = useTaste()

  if (!selectedPack) return null

  const isSpecialRate = selectedPack.size === 8

  return (
    <div className="mb-8">
      <div
        className={`rounded-2xl border-3 transition-all duration-300 overflow-hidden ${
          hasCaviar
            ? 'border-[#DAA520] bg-gradient-to-br from-amber-950/30 to-[#1a1a1a] shadow-xl'
            : 'border-white/20 bg-[#1a1a1a]'
        }`}
      >
        <div className="flex flex-col md:flex-row items-center p-6 gap-6">
          {/* Caviar Image */}
          <div className="w-32 h-32 flex-shrink-0 rounded-xl overflow-hidden bg-white/10">
            <img
              src={useAsset('/sasanian_1oz.png')}
              alt="Premium Sasanian Siberian Caviar"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-bold !text-white mb-1 font-heading">
              Add the Finishing Touch.
            </h3>
            <p className="!text-white/60 mb-3">
              Include a 1oz tin of premium Sasanian Siberian Caviar with your order.
            </p>
            <div className="flex items-center justify-center md:justify-start gap-3">
              <span className={`text-2xl font-bold ${hasCaviar ? '!text-[#DAA520]' : '!text-white'}`}>
                +${caviarPrice.toFixed(2)}
              </span>
              {isSpecialRate && (
                <span className="text-sm font-semibold !text-[#DAA520] bg-[#DAA520]/10 px-3 py-1 rounded-full">
                  Included at a special rate
                </span>
              )}
            </div>
          </div>

          {/* Toggle */}
          <div className="flex-shrink-0">
            <button
              onClick={() => setHasCaviar(!hasCaviar)}
              className={`relative w-16 h-11 rounded-full transition-all duration-300 ${
                hasCaviar
                  ? 'bg-[#DAA520]'
                  : 'bg-white/30'
              }`}
            >
              <div
                className={`absolute top-1.5 w-8 h-8 bg-white rounded-full shadow-md transition-all duration-300 ${
                  hasCaviar ? 'left-7' : 'left-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CaviarUpsell
